module.exports = __webpack_public_path__ + "img/v4_jg.142a413a.svg";